import React, { useEffect, useState } from 'react';
import Marquee from './Marquee';
import '../styles/marquee.css';

const reviews = [
    {
        name: "Karan M V",
        role: "Director, International Developer Relations at GitHub",
        body: "Appreciated the TeachGenie™ platform and recommended a few improvements related to security compliance to further strengthen the system.",
        img: "/Testimonial/karan-mv.jpg"
    },
    {
        name: "Dr. Shilpa Desai",
        role: "CEO, Eros HealthScience and R&D",
        body: "TeachGenie™ has a strong long-term vision for transforming education. I’m interested in supporting the platform and helping by providing access to data from schools.",
        img: "/Testimonial/shilpa-desai.jpg"
    },
    {
        name: "Anubhav Sethi",
        role: "SWE 3, Google",
        body: "Tried and suggested a few improvements that could make the experience even more impactful for teachers.",
        img: "/Testimonial/anubhav-sethi.jpg"
    },
    {
        name: "Jayant Sharma",
        role: "Senior Software Engineer, Google",
        body: "Appreciated the discussion about Google Classroom and how TeachGenie™ can support educators in managing their classrooms more efficiently.",
        img: "/Testimonial/jayant-sharma.jpg"
    },
    {
        name: "Jaideep Prasad",
        role: "Founder, Mentro | Product lead, Classplus",
        body: "The PDF exports are publication-ready. My TAs save countless hours every week.",
        img: "/Testimonial/jaideep-prasad.jpg"
    }
];

const firstRow = [...reviews.slice(0, reviews.length / 2), ...reviews.slice(0, reviews.length / 2)];
const secondRow = [...reviews.slice(reviews.length / 2), ...reviews.slice(reviews.length / 2)];

const ReviewCard = ({ img, name, role, body }) => {
    return (
        <figure className="review-card">
            <div className="review-header">
                <img className="review-avatar" alt={name} src={img} />
                <div className="review-info">
                    <p className="review-name">{name}</p>
                    <p className="review-role">{role}</p>
                </div>
            </div>
            <blockquote className="review-body">"{body}"</blockquote>
            <div className="review-stars">
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
                <span className="star">★</span>
            </div>
        </figure>
    );
};

const Testimonials = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className="testimonial-section">
            <div className="testimonial-header">
                <h2>Loved by Educators Worldwide</h2>
                <p>See what teachers and professors are saying about TeachGenie™.ai</p>
            </div>

            {isMobile ? (
                <div className="testimonial-mobile-grid">
                    {reviews.map((review, index) => (
                        <ReviewCard key={`mobile-review-${index}`} {...review} />
                    ))}
                </div>
            ) : (
                <div className="marquee-wrapper">
                    <Marquee pauseOnHover duration={80}>
                        {firstRow.map((review, index) => (
                            <ReviewCard key={index} {...review} />
                        ))}
                    </Marquee>
                    <Marquee reverse pauseOnHover duration={80}>
                        {secondRow.map((review, index) => (
                            <ReviewCard key={index} {...review} />
                        ))}
                    </Marquee>
                </div>
            )}
        </section>
    );
};

export default Testimonials;
